import { _axios } from '../plugins/axios'
import  api  from '../config';

//提取封装 get post ；
const axios = {
    'get': (apiName,data) => _axios.get(api.api + apiName,{
        params:data,
    }),
    'post': (apiName,data) => _axios.post(api.api + apiName,data),
	'put': (apiName,data) => _axios.put(api.api + apiName,data),
}
export {
    axios
}

